import { AxiosError } from 'axios';
import { z } from 'zod';

import { FranchiseSalesOrganizationFormSchema } from '@/components/forms/schemas/FranchiseSalesOrganizationFormSchema';
import { CONSULTANT_INDUSTRIES_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ConsultantIndustries } from '@/types/consultant.type';
import { ApiResponse } from '@/types/response.type';

export type CreateConsultantIndustriesApiPayload = z.infer<
  typeof FranchiseSalesOrganizationFormSchema
> & {
  industry_background: string[];
};

export const createConsultantIndustries = async (
  payload: CreateConsultantIndustriesApiPayload
): Promise<ApiResponse<ConsultantIndustries>> => {
  try {
    const response = await apiManager.post(
      CONSULTANT_INDUSTRIES_API_URL,
      payload,
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
